import React from 'react';
import SharedDataStep from '../shared/DataStep';
import { DEPOSITION_OPTIONS, INTERNMENT_OPTIONS } from '../shared/options';
import { DELETE_GRAVE } from '../../graphql/mutations';
import { GRAVES_QUERY } from '../../graphql/queries';

const graveFields = (state) => [
  { key: 'identifier', label: 'Identifier', type: 'text', value: state.identifier },
  {
    key: 'depositionType',
    label: 'Deposition Type',
    type: 'select',
    options: DEPOSITION_OPTIONS,
    value: state.depositionType
  },
  {
    key: 'internmentType',
    label: 'Internment Type',
    type: 'select',
    options: INTERNMENT_OPTIONS,
    value: state.internmentType
  }
];

export default function DataStep({ grave, state, onNext, onCancel, loading }) {
  return (
    <SharedDataStep
      title="Basic Grave Data"
      resource={{ ...grave, identifier: state.identifier, type: 'Grave' }}
      fields={graveFields(state)}
      deletion={{
        resource: { ...grave, query: GRAVES_QUERY },
        mutation: DELETE_GRAVE,
        redirectPath: '/graves',
        label: 'Grave'
      }}
      onNext={onNext}
      onCancel={onCancel}
      loading={loading}
    />
  );
}
